export default __webpack_public_path__ + "static/media/1.1.1.a08f4baf.png";